import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import { cn } from "@/lib/utils";
function HoverCard(t0) {
  const $ = _c(8);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      openDelay: t1,
      closeDelay: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const openDelay = t1 === undefined ? 0 : t1;
  const closeDelay = t2 === undefined ? 0 : t2;
  let t3;
  if ($[4] !== closeDelay || $[5] !== openDelay || $[6] !== props) {
    t3 = <HoverCardPrimitive.Root data-slot="hover-card" openDelay={openDelay} closeDelay={closeDelay} {...props} />;
    $[4] = closeDelay;
    $[5] = openDelay;
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function HoverCardTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <HoverCardPrimitive.Trigger data-slot="hover-card-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function HoverCardContent(t0) {
  const $ = _c(16);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      sideOffset: t2,
      hoverBridge: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  const hoverBridge = t3 === undefined ? true : t3;
  let t4;
  if ($[6] !== hoverBridge) {
    t4 = hoverBridge && ["before:absolute before:bg-transparent before:content-['']", "data-[side=right]:before:-left-3 data-[side=right]:before:top-0 data-[side=right]:before:h-full data-[side=right]:before:w-3", "data-[side=left]:before:-right-3 data-[side=left]:before:top-0 data-[side=left]:before:h-full data-[side=left]:before:w-3", "data-[side=top]:before:-bottom-3 data-[side=top]:before:left-0 data-[side=top]:before:h-3 data-[side=top]:before:w-full", "data-[side=bottom]:before:-top-3 data-[side=bottom]:before:left-0 data-[side=bottom]:before:h-3 data-[side=bottom]:before:w-full"];
    $[6] = hoverBridge;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className || $[9] !== t4) {
    t5 = cn("z-50 w-64 rounded-md border border-[var(--color-border)] bg-white p-4 text-neutral-950 shadow-md outline-hidden dark:border-[#444545] dark:bg-[#2A2C2C] dark:text-neutral-50", t4, className);
    $[8] = className;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== align || $[12] !== props || $[13] !== sideOffset || $[14] !== t5) {
    t6 = <HoverCardPrimitive.Portal data-slot="hover-card-portal"><HoverCardPrimitive.Content data-slot="hover-card-content" align={align} sideOffset={sideOffset} className={t5} {...props} /></HoverCardPrimitive.Portal>;
    $[11] = align;
    $[12] = props;
    $[13] = sideOffset;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export { HoverCard, HoverCardTrigger, HoverCardContent };